'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmRegistrationController = function ConfirmRegistrationController($stateParams, Account) {
  "ngInject";

  (0, _classCallCheck3.default)(this, ConfirmRegistrationController);
  var vm = this;
  vm.name = 'confirmRegistration';
  vm.message = '';
  vm.init = init;
  vm.init();

  function init() {
    Account.confirmRegistration($stateParams.key).then(function () {
      vm.message = "Registrazione avvenuta con successo.";
    }).catch(function () {
      vm.message = "Questo link non è valido oppure è già stato utilizzato";
    });
  }
};

exports.default = ConfirmRegistrationController;


// WEBPACK FOOTER //
// ./client/app/components/confirmRegistration/confirmRegistration.controller.js